import React, { useState } from 'react';
import { Box } from '@mui/material';

export const NO_IMAGE_PLACEHOLDER = '/assets/images/no-image-placeholder.png';

/**
 * Standardized Image with automatic fallback to GPN "No Image" placeholder.
 * Handles missing source, empty string, null/undefined, and image load errors (404/broken).
 * Preserves dimensions, border radius, and aspect ratio.
 */
const ImageWithPlaceholder = ({
  src,
  alt = 'Image',
  width = '100%',
  height = '100%',
  style = {},
  sx = {},
  objectFit = 'cover',
  className = '',
  borderRadius = 1.5,
  onClick,
  ...props
}) => {
  const [hasError, setHasError] = useState(false);

  // If no source is provided or image loading failed, use standard placeholder
  const imageSource = (!src || src === '' || src === 'null' || src === 'undefined' || hasError)
    ? NO_IMAGE_PLACEHOLDER
    : src;

  return (
    <Box
      sx={{
        width,
        height,
        position: 'relative',
        overflow: 'hidden',
        borderRadius,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(15, 23, 42, 0.4)',
        cursor: onClick ? 'pointer' : 'default',
        ...sx,
      }}
      onClick={onClick}
    >
      <img
        src={imageSource}
        alt={alt}
        onError={() => setHasError(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit: objectFit,
          display: 'block',
          ...style,
        }}
        {...props}
      />
    </Box>
  );
};

export default ImageWithPlaceholder;
